export default __webpack_public_path__ + "static/media/been-there-blue.a54b0e07.svg";